/**
 * Admin: Add / edit blog only (category, author, SEO, etc.).
 */
import { Link } from "react-router-dom";
import "./AddRealWeddingPage.css";
import { useContentForm } from "../hooks/useContentForm";
import {
  ContentFormShell,
  ContentBasicFields,
  ContentBlogMetaFields,
  ContentDescriptionField,
  ContentGallerySection,
} from "../Components/ContentFormSections";

function AddBlogPage() {
  const formApi = useContentForm("blog");
  const {
    isEditMode,
    form,
    errors,
    success,
    coverFile,
    postLoading,
    getOneLoading,
    getOneError,
    loadTypeMismatch,
    coverInputRef,
    galleryInputRefs,
    multiFileInputRef,
    setField,
    setPhoto,
    handleCoverChange,
    handleGalleryChange,
    handleMultiSelect,
    removeCover,
    addPhoto,
    removePhoto,
    resetForAnother,
    handleSubmit,
  } = formApi;

  const listPath = "/admin/blogs";
  const pageTitle = isEditMode ? "Update Blog" : "Add Blog";
  const subtitle = success
    ? isEditMode
      ? "Blog has been updated."
      : "Blog has been added. It will appear on the Blog page."
    : isEditMode
      ? "Edit heading, cover photo, description and blog details."
      : "Add a new blog with heading, cover photo, description and gallery images.";

  return (
    <ContentFormShell
      backTo={listPath}
      backLabel="← Blogs"
      title={pageTitle}
      subtitle={subtitle}
      loading={isEditMode && getOneLoading}
      loadError={isEditMode && (getOneError || loadTypeMismatch)}
      loadErrorText={
        loadTypeMismatch
          ? "This item is a real wedding. Open it from the Real Weddings list."
          : "Failed to load blog."
      }
      success={success}
      successTitle={isEditMode ? "Blog updated" : "Blog added"}
      successText="You can add another or go back to the list."
      onAddAnother={resetForAnother}
    >
      <form onSubmit={handleSubmit} className="admin-data-form">
        <h2 className="admin-create-business-step-title">Blog</h2>

        <ContentBasicFields
          idPrefix="blog"
          form={form}
          errors={errors}
          postLoading={postLoading}
          coverFile={coverFile}
          coverInputRef={coverInputRef}
          setField={setField}
          handleCoverChange={handleCoverChange}
          removeCover={removeCover}
        />

        <div className="admin-form-section">
          <ContentBlogMetaFields idPrefix="blog" form={form} errors={errors} setField={setField} />
          <ContentDescriptionField
            idPrefix="blog"
            form={form}
            errors={errors}
            setField={setField}
            placeholder="Blog content (bold, lists, links supported)"
          />
        </div>

        <ContentGallerySection
          form={form}
          errors={errors}
          postLoading={postLoading}
          galleryInputRefs={galleryInputRefs}
          multiFileInputRef={multiFileInputRef}
          setPhoto={setPhoto}
          handleGalleryChange={handleGalleryChange}
          handleMultiSelect={handleMultiSelect}
          addPhoto={addPhoto}
          removePhoto={removePhoto}
          sectionTitle="Blog images"
        />

        <div className="admin-form-actions">
          <Link to={listPath} className="admin-form-btn admin-form-btn-cancel">
            Cancel
          </Link>
          <button
            type="submit"
            className="admin-form-btn admin-form-btn-submit"
            disabled={postLoading}
          >
            {postLoading ? "Saving…" : isEditMode ? "Update Blog" : "Add Blog"}
          </button>
        </div>
      </form>
    </ContentFormShell>
  );
}

export default AddBlogPage;
